import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "@/features/axiosHelper";

const connectionsBarSlice = createSlice({
  name: "connectionsBar",
  initialState: {
    connections: [],
    customerConnections: [],
    status: "initial",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getFavouriteCustomers.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(getFavouriteCustomers.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(getFavouriteCustomers.fulfilled, (state, action) => {
        state.status = "loaded";
        state.connections = action.payload.data;
      })
      .addCase(getCustomerConnections.pending, (state, _) => {
        state.status = "loading";
      })
      .addCase(getCustomerConnections.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(getCustomerConnections.fulfilled, (state, action) => {
        state.status = "loaded";
        state.customerConnections = action.payload.data;
      });
  },
});

export const getCustomerConnections = createAsyncThunk(
  "connectionsBar/getCustomerConnections",
  async () => {
    const response = await axios.get("/connections/customer-connections");
    return response;
  }
);

export const getFavouriteCustomers = createAsyncThunk(
  "connectionsBar/getFavouriteCustomers",
  async () => {
    const response = await axios.get(
      "/connections/customer-connection-favourites",
    );
    return response;
  }
);

export const saveFavouriteCustomers = createAsyncThunk(
  "connectionsBar/saveFavouriteCustomers",
  async (favouriteConnectionList) => {
    const response = await axios.post(
      "/connections/customer-connection-favourites",
      null,
      {
        params: {
          customerList: favouriteConnectionList,
        },
      }
    );
    return response;
  }
);

export const selectCustomerFilterConnections = (state) =>
  state.tempInfo.connectionsBar.connections;
export const selectAvaliableCustomerConnections = (state) =>
  state.tempInfo.connectionsBar.customerConnections;

export default connectionsBarSlice.reducer;
